import { Skeleton } from '@medifind/shared-basic-components';
import styles from './CardLabelledValue.module.scss';

const CardLabelledValue = ({ label, value }) => {
  if (!value) {
    return <Skeleton />;
  }

  return (
    <div className={styles['card-labelled-value']}>
      <div>{label}</div>
      <div className={styles['card-labelled-value__content']}>{value}</div>
    </div>
  );
};

export { CardLabelledValue as default, CardLabelledValue };
